import React from 'react';
import PropTypes from 'prop-types';
import './style.css';
import { useId } from 'utils/hooks/useId';

const OptionCheckbox = ({ checked, onChange, label }) => {
  const inputId = useId();
  return (
    <label className="option-checkbox" htmlFor={inputId}>
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <span className="option-checkbox-mask" />
      <span className="option-checkbox-label">{label}</span>
    </label>
  );
};

OptionCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default OptionCheckbox;
